import Vue from 'vue';
import VueCookies from 'vue-cookies';
import Plotly from 'plotly.js-dist';
import PrimeVue from 'primevue/config';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import Toasted from 'vue-toasted';
import VueMarkdown from 'vue-markdown';
import contribution from 'vue-contribution';
import VueMarkdownEditor from '@kangc/v-md-editor';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress';
import zhTW from '@kangc/v-md-editor/lib/lang/zh-TW';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import Prism from 'prismjs';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import FloatingVue from 'floating-vue';
import VueMobileDetection from 'vue-mobile-detection';
import VueGtag from 'vue-gtag';
import { VTooltip } from 'v-tooltip';

import App from './App.vue';
import router from './router';
import store from './store';
import init from './assets/api/default';

import 'normalize.css';
import 'vue-contribution/dist/vue-contribution.css';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';
import 'prismjs/components/prism-json';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import 'floating-vue/dist/style.css';
// theme
import 'primevue/resources/themes/lara-light-blue/theme.css';
// core
import 'primevue/resources/primevue.min.css';
// icons
import 'primeicons/primeicons.css';

Vue.prototype.$plotly = Plotly;

Vue.config.productionTip = false;

init(store);

router.beforeEach((to, from, next) => {
  const tokenRecord = VueCookies.get('CWLUser');
  let token;
  let userId;

  if (tokenRecord) {
    token = tokenRecord.token;
    userId = tokenRecord.id;
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (token) {
      const role = userId.slice(0, 2);
      if (to.matched.some((record) => record.meta.role.includes(role))) {
        next();
      } else {
        next('/');
      }
    } else {
      VueCookies.remove('CWLUser');
      next('/login');
    }
  } else if (to.path === '/login') {
    if (token) next('/');
    else next();
  } else {
    next();
  }
});

// FontAwesomeIcon
library.add(fas, far);
dom.watch();
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.component('vue-markdown', VueMarkdown);
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

Vue.use(Toasted);
Vue.use(contribution);
Vue.use(VueCookies);
Vue.use(PerfectScrollbar);
Vue.use(FloatingVue);
Vue.use(VueMobileDetection);
Vue.use(PrimeVue);
Vue.use(VTooltip);

Vue.use(VueGtag, {
  config: {
    id: 'G-8ZGKPXL1WB',
    params: {
      send_page_view: false,
    },
  },
});

VueMarkdownEditor.use(vuepressTheme, {
  Prism,
});
VueMarkdownEditor.lang.use('zh-TW', zhTW);
Vue.use(VueMarkdownEditor);

const toastCommonObj = {
  iconPack: 'fontawesome',
  position: 'top-center',
  duration: 3000,
  keepOnHover: true,
};

Vue.toasted.register('action_success', (payload) => payload.message, {
  ...toastCommonObj,
  ...{
    icon: 'check-circle',
    className: ['action-success'],
  },
});

Vue.toasted.register('action_error', (payload) => payload.message, {
  ...toastCommonObj,
  ...{
    icon: 'exclamation-triangle',
    className: ['action-error'],
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
